import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHead } from "../components/ui-bits";
import { toast } from "sonner";
import {
  AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid
} from "recharts";
import { DownloadSimple, FilePdf } from "@phosphor-icons/react";

const tip = { contentStyle: { background: "#111", border: "none", borderRadius: 2, color: "#fff", fontSize: 12 } };

const PDF_REPORTS = [
  { type: "mis", name: "Management MIS Report", desc: "Performance, liquidity & statutory dues", file: "Virtualeena_MIS.pdf" },
  { type: "pnl", name: "Profit & Loss Statement", desc: "Revenue, COGS, EBITDA & net profit", file: "Virtualeena_PnL.pdf" },
  { type: "balance-sheet", name: "Balance Sheet", desc: "Assets, liabilities & owner's equity", file: "Virtualeena_BalanceSheet.pdf" },
];

export default function Reports() {
  const [forecast, setForecast] = useState([]);
  const [busy, setBusy] = useState(null);
  useEffect(() => {
    api.get("/cashflow-forecast").then((r) => setForecast(r.data.forecast)).catch(() => {});
  }, []);

  const downloadPdf = async (r) => {
    setBusy(r.type);
    try {
      const res = await api.get(`/reports/${r.type}/pdf`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = r.file; a.click();
      URL.revokeObjectURL(url);
      toast.success(`${r.name} downloaded`);
    } catch { toast.error("Could not generate PDF"); }
    finally { setBusy(null); }
  };

  return (
    <div>
      <PageHead eyebrow="Financials & Forecast" title="Reports" />

      <div className="card p-6 mb-6">
        <p className="label mb-4">30-Day Cash Flow Forecast (₹ '000)</p>
        <ResponsiveContainer width="100%" height={240}>
          <AreaChart data={forecast}>
            <CartesianGrid strokeDasharray="2 2" vertical={false} stroke="#eee" />
            <XAxis dataKey="period" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} />
            <Tooltip {...tip} />
            <Area type="monotone" dataKey="position" name="Cash Position" stroke="#002FA7" fill="#002FA7" fillOpacity={0.1} strokeWidth={2} />
            <Area type="monotone" dataKey="receipts" name="Receipts" stroke="#00A86B" fill="#00A86B" fillOpacity={0.05} />
            <Area type="monotone" dataKey="payments" name="Payments" stroke="#FF3B30" fill="#FF3B30" fillOpacity={0.05} />
          </AreaChart>
        </ResponsiveContainer>
      </div>

      <p className="label mb-3">Downloadable Reports (PDF)</p>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {PDF_REPORTS.map((r) => (
          <div key={r.type} data-testid={`report-${r.type}`} className="card p-5 flex flex-col justify-between">
            <div>
              <FilePdf size={26} className="text-[#DC2626] mb-3" weight="fill" />
              <h3 className="font-head font-bold">{r.name}</h3>
              <p className="text-xs text-[#888] mt-1">{r.desc}</p>
            </div>
            <button data-testid={`download-${r.type}`} onClick={() => downloadPdf(r)} disabled={busy === r.type}
              className="mt-4 flex items-center justify-center gap-2 text-sm bg-[#002FA7] hover:bg-[#00227A] text-white rounded-sm py-2 transition-colors disabled:opacity-50">
              <DownloadSimple size={16} /> {busy === r.type ? "Generating…" : "Download PDF"}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

